import { gql } from "@apollo/client";

export const ATTACHMENTS = gql`
  query Attachments(
    $where: AttachmentWhereInput
    $whereNot: AttachmentWhereInput
    $isIn: JSONObject
  ) {
    attachments(where: $where, whereNot: $whereNot, isIn: $isIn) {
      data {
        id
        identifier
        name
        key
        filename
        fileUrl
        contentType
        type
        createdDate
        user {
          id
        }
      }
      count
    }
  }
`;

/** Lightweight query to load DOCUMENT_STEPS params for upsell plans. */
export const INSURANCE_PLANS_DOCUMENT_STEPS = gql`
  query InsurancePlansDocumentSteps($isIn: JSONObject, $take: Int) {
    insurancePlans(isIn: $isIn, take: $take) {
      data {
        id
        params {
          id
          rules {
            name
            value
          }
        }
      }
    }
  }
`;

const attachments = { ATTACHMENTS, INSURANCE_PLANS_DOCUMENT_STEPS };

export default attachments;
